import React, { Component } from 'react';
import LightboxTrigger from '../LightboxTrigger/LightboxTrigger';
import { Link } from 'react-router-dom';
import pdfIcon from './pdf.svg';
class ProductGridRow extends Component {


    render() {

        function productSheet(pdf){
            if(pdf !== ""){
                return (
                    <p className="more">
                        <Link to={"/pdf/" + pdf} className="pdfLink" target="_blank">
                        <img className="pdfIcon" src={pdfIcon} alt="PDF"/>
                         Download Product Sheet
                        </Link>
                    </p>
                );
            }
        }

        function productSheets(pdfs){
            if(pdfs && pdfs.length){
                return (
                    <div className="more">
                        {pdfs.map((pdf, index) => {
                            return (
                                <p key={index}>
                                    <Link to={"/pdf/" + pdf.file} className="pdfLink" target="_blank">
                                    <img className="pdfIcon" src={pdfIcon} alt="PDF"/>
                                    Download {pdf.title} Product Sheet
                                    </Link>
                                </p>
                            )
                        })}

                    </div>
                );
            }
        }

        function samplesButton(flag, data){
            if(flag){
                return (
                    <LightboxTrigger
                        buttonClass="btn btn-primary btn-block"
                        index={data.index}
                        images={data.images}
                        captions={data.captions}
                    >
                        View Samples
                    </LightboxTrigger>
                );
            }
        }

        return (
            <div className="row product-grid-row">
                <div className="description col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3">

                    {this.props.children}

                    {productSheet(this.props.data.pdf)}

                    {productSheets(this.props.data.pdfs)}

                </div>
                <div className="samples col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9">
                    <LightboxTrigger
                            buttonClass="transparent"
                            index={this.props.data.index}
                            images={this.props.data.images}
                            captions={this.props.data.captions}
                        >
                        <img className="sample-image" src={this.props.data.sampleImage} alt={this.props.data.sampleAlt}/>
                    </LightboxTrigger>

                    {samplesButton(this.props.data.showButton, this.props.data)}
                </div>
            </div>
        );
    }
}

export default ProductGridRow;



// WEBPACK FOOTER //
// ./src/components/ProductGridRow/ProductGridRow.js